import Button from "components/ui/Button/Button";
import Trans from "features/translation/components/Trans";
import ConversationTeaser from "pages/MessageBox/ConversationTeaser";
import { useAccount } from "context/AccountContext";
import { useHistory } from "react-router-dom";
import Loader from "components/ui/Loader/Loader";
import { useMessageBox } from "pages/MessageBox/MessageBoxContext";
import ViewConversationsHeader from "pages/MessageBox/ViewConversationsHeader";

const ViewConversations = () => {
  const { user } = useAccount();
  const history = useHistory();

  const {
    conversationsLoading,
    conversations,
    selectedConversation,
    setSelectedConversation,
    filter,
  } = useMessageBox();

  const findProfileRef = (uid) => {
    return conversations.refs.profile.find(
      (item) => item.uid === parseInt(uid)
    );
  };

  let content;
  if (conversations?.results?.length) {
    content = conversations.results
      .map((row) => {
        const senderId = parseInt(row.sender_uid);
        const receiverId = parseInt(row.receiver_uid);

        let userId = senderId;
        if (senderId === user.id) {
          userId = receiverId;
        }

        const profile = findProfileRef(userId);
        if (!profile) {
          return null;
        }

        return (
          <ConversationTeaser
            key={userId}
            profile={profile}
            created={row.created.short}
            unreadCount={parseInt(row.unread)}
            isActive={parseInt(selectedConversation) === userId}
            onClick={() => setSelectedConversation(userId)}
          />
        );
      })
      .filter(Boolean);
  }

  return (
    <>
      <ViewConversationsHeader />
      {conversations?.results?.length === 0 &&
        !filter &&
        !conversationsLoading && (
          <>
            <div className={"margin-bottom-small"}>
              <Trans
                text={"U heeft nog geen berichten verstuurd of ontvangen."}
              />
            </div>
            <Button
              variant={"secondary"}
              onClick={() => history.push("/leden")}
              className={"button--full-width"}
            >
              Leden zoeken
            </Button>
          </>
        )}

      {conversationsLoading ? <Loader /> : content}
    </>
  );
};

export default ViewConversations;
